// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__2OIy4","isLoading":"Loader_isLoading__2L4iJ","notTransparent":"Loader_notTransparent__3-Jwd","lds_roller":"Loader_lds_roller__3nJMG"};